export default __webpack_public_path__ + "static/media/admin-user.1dca4d0a.png";